import { ADMIN_CONTEXT, LOGIN } from '../../constants/actions';
import { ALL_ORGS_CONTEXT } from '../../constants/admin/settings';
import { LOCATION_CHANGE } from 'react-router-redux';
import { get } from 'lodash';

const initialState = {
    subject: ALL_ORGS_CONTEXT.id,
    options: [],
    ready: false
};

function context(state = initialState, action) {
    switch (action.type) {
        case ADMIN_CONTEXT.OPTIONS:
            return { ...state, options: action.options };
        case ADMIN_CONTEXT.SET:
            return { ...state, subject: action.subject, ready: true };
        case ADMIN_CONTEXT.ADD:
            return { ...state, options: [...state.options, action.newItem] };
        case ADMIN_CONTEXT.UPDATE:
            return {
                ...state,
                options: state.options.map(o => (o.id === action.id ? { id: action.id, name: action.name } : o))
            };
        case LOGIN.CANCEL:
            return initialState;
        case LOCATION_CHANGE:
            const isAdmin = get(action, 'payload.pathname', '').includes('/admin');
            return { ...state, ready: state.ready && isAdmin ? true : false };
        default:
            return state;
    }
}

export default context;
